import React, { useEffect, useState } from "react";
import "./Table.scss";
export interface Props {
  cols: Array<any>;
  data: Array<any>;
  bordered?: boolean;
  hoverable?: boolean;
  striped?: boolean;
  isDark?: boolean;
  searchable?: boolean;
  customClass?: string;
  customId?: string;
  tableCaption?: string;
  sortable?: boolean;
}
const Table = ({
  cols,
  data,
  bordered,
  hoverable,
  striped,
  isDark,
  searchable,
  customClass,
  customId,
  tableCaption,
  sortable = false,
}: Props) => {
  const [search, setSearch] = useState<any[]>(data);
  const hadleSearch = (e: any) => {
    const val = e.target.value;
    if (val) {
      setTimeout(() => {
        setSearch([
          ...data.filter((row: any) => {
            return Object.values(row).join("").toLowerCase().includes(val);
          }),
        ]);
      }, 2000);
    } else {
      setTimeout(() => {
        setSearch(data);
      }, 2000);
    }
  };
  useEffect(() => {
    setSearch(data);
  }, [data]);

  const sortBy = (key: string) => {
    const sorted = [...search].sort((a, b) =>
      a[key]
        ?.toString()
        .toLowerCase()
        .localeCompare(b[key]?.toString().toLowerCase())
    );
    setSearch(sorted);
  };
  return (
    <div className="mfg-tableWrap">
     <div className="tableOptions">
        {searchable && (
          <div className="search">
            <label htmlFor="search">Search</label>
            <input
              id="search"
              type="search"
              placeholder="Search..."
              onChange={hadleSearch}
            />
          </div>
        )}
        {sortable && (
          <div className="sort">
            <label htmlFor="sortBy">Sort By : </label>
            <select id="sortBy" onChange={(e) => sortBy(e.target.value)}>
              {cols?.map((headerItem: any, index: any) => (
                <option
                  key={index}
                  data-title={headerItem.title}
                  value={headerItem.title.toLowerCase()}
                >
                  {headerItem.title}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <table
        id={customId}
        className={`table ${bordered ? " " + "table-bordered" : ""} ${
          hoverable ? " " + "table-hover" : ""
        } ${striped ? " " + "table-striped" : ""} ${
          isDark ? " " + "table-dark" : ""
        }${customClass ? " " + customClass : ""}`}
      >
        { tableCaption && <caption className="srOnly"> {tableCaption} </caption>}
        <thead>
          <tr>
            {cols?.map((headerItem: any, index: any) => (
              <th key={index} data-title={headerItem.title}>
                {headerItem.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {search.length !== 0
            ? search?.map((item: any, index: any) => (
                <tr key={index}>
                  {cols.map((col: any, key: any) => (
                    <td data-title={col.title} key={key}>
                      {col.render(item)}
                    </td>
                  ))}
                </tr>
              ))
            : data?.map((item: any, index: any) => (
                <tr key={index}>
                  {cols.map((col: any, key: any) => (
                    <td data-title={col.title} key={key}>
                      {col.render(item)}
                    </td>
                  ))}
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
